import { useProformaInvoicesOptionsQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useStore } from "../store";

export const useFetchTableOptions = () => {
  const store = useStore();

  const { loading } = useProformaInvoicesOptionsQuery({
    onCompleted(data) {
      if (data) {
        store.setOptions(data);
      }
    },
    ...onError(),
  });

  return { loading };
};
